<template>
  <v-app>
    <v-container fluid class="pa-0">
      <v-row v-if="$insertAccess($route.fullPath)">
        <v-col cols="12">
          <!-- Employee Selection Section -->
          <v-expansion-panels v-model="panel" class="mb-1">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Employee Selection
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pa-0">
                <v-form ref="employeeForm" id="employeeForm" class="pa-0">
                  <v-row class="ma-0">
                    <v-col lg="6" md="6" cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="employee_id"
                        :items="employees"
                        :item-title="(item) => `${item.name} - ${item.code || item.employee_code || item.emp_id || ''}`"
                        item-value="id"
                        :loading="employeesLoading"
                        autocomplete="off"
                        clearable
                        hide-details="auto"
                        @update:model-value="loadEmployeeDetails"
                        no-data-text="No employees found"
                        placeholder="Select an employee"
                      >
                        <template #label>
                          Employee
                          <span class="text-red-accent-4">*</span>
                        </template>
                        <template #append-inner>
                          <v-btn
                            icon="mdi-refresh"
                            size="small"
                            variant="text"
                            @click="loadEmployees"
                            :loading="employeesLoading"
                          ></v-btn>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col lg="6" md="6" cols="12" class="pa-1 d-flex align-center">
                      <v-chip 
                        v-if="employees.length > 0" 
                        color="success" 
                        size="small"
                      >
                        {{ employees.length }} employees loaded
                      </v-chip>
                      <v-chip 
                        v-else-if="!employeesLoading" 
                        color="warning" 
                        size="small"
                      >
                        No employees found
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>


                  <!-- Employee Details Display -->
          <v-expansion-panels v-model="panel1" class="mt-0 mb-1" v-if="employeeDetails.name">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Employee Details
              </v-expansion-panel-title>
              <v-expansion-panel-text class="pa-0">
                <v-card variant="outlined" class="pa-0">
                    <v-card-title class="text-subtitle-1 mb-0 pa-1">
                      <v-icon class="me-1" size="small">mdi-account</v-icon>
                      Employee Information
                    </v-card-title>
                    <v-form class="pa-0">
                      <v-row class="ma-0">
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.emp_id"
                            label="EMP ID"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.name"
                            label="Name"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.department"
                            label="Current Department"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.designation"
                            label="Current Designation"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.joining_date"
                            label="Joining Date"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.mobile"
                            label="Mobile"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.email"
                            label="Email"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pa-1">
                          <v-text-field
                            v-model="employeeDetails.employee_type"
                            label="Employee Type"
                            readonly
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                </v-card>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Promotion Form Section -->
          <v-expansion-panels v-model="panel2" class="mt-0" multiple>
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Add Promotion Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit" ref="addPromotion" id="addPromotion">

                    <!-- Promotion Details Section -->
                  <v-card variant="outlined" class="pa-1 mb-1">
                    <v-card-title class="text-subtitle-1 mb-0 pa-1">
                      <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                      Promotion Details
                    </v-card-title>
                    <v-form class="pa-0">
                      <v-row class="ma-0">
                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                            v-model="ref_no"
                        autocomplete="off"
                        clearable
                            hide-details="auto"
                      >
                        <template #label>
                              Ref No.
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>
                        </v-col>

                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                            v-model="promotion_type"
                        :items="promotionTypes"
                        :item-title="(item) => `${item.text}`"
                        item-value="value"
                        :loading="loading"
                        autocomplete="off"
                        clearable
                            hide-details="auto"
                      >
                        <template #label>
                          Promotion Type
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                        </v-col>

                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-menu
                        v-model="promotionDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="promotion_date"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            readonly
                            v-bind="props"
                            hide-details="auto"
                          >
                            <template #label>
                              Promotion Date
                              <span class="text-red-accent-4">*</span>
                            </template>
                            <template #append-inner>
                              <v-icon color="primary">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="promotion_date"
                          color="primary"
                          show-adjacent-months
                          elevation="3"
                          no-timezone
                          format="yyyy-MM-dd"
                          @update:model-value="(date) => { promotion_date = formatDateToString(date); promotionDateMenu = false }"
                        ></v-date-picker>
                      </v-menu>
                        </v-col>

                        <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-menu
                        v-model="effectDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ props }">
                          <v-text-field
                            v-model="effect_date"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            readonly
                            v-bind="props"
                            hide-details="auto"
                          >
                            <template #label>
                              Effect Date
                              <span class="text-red-accent-4">*</span>
                            </template>
                            <template #append-inner>
                              <v-icon color="primary">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="effect_date"
                          color="primary"
                          show-adjacent-months
                          elevation="3"
                          no-timezone
                          format="yyyy-MM-dd"
                          @update:model-value="(date) => { effect_date = formatDateToString(date); effectDateMenu = false }"
                        ></v-date-picker>
                      </v-menu>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>

                  <!-- Department and Designation Changes -->
                  <v-card variant="outlined" class="pa-1 mb-1">
                    <v-card-title class="text-subtitle-1 mb-0 pa-1">
                      <v-icon class="me-1" size="small">mdi-office-building</v-icon>
                      Department & Designation Changes
                    </v-card-title>
                    <v-form class="pa-0">
                      <v-row class="ma-0">
                        <v-col lg="6" md="6" cols="12" class="pa-1">
                          <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="from_department_id"
                            :items="departments"
                            :item-title="(item) => `${item.name}`"
                            item-value="id"
                            :loading="departmentsLoading"
                            autocomplete="off"
                            clearable
                            hide-details="auto"
                          >
                            <template #label>
                              From Department
                              <span class="text-red-accent-4">*</span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" class="pa-1">
                          <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="to_department_id"
                            :items="departments"
                            :item-title="(item) => `${item.name}`"
                            item-value="id"
                            :loading="departmentsLoading"
                            autocomplete="off"
                            clearable
                            hide-details="auto"
                          >
                            <template #label>
                              To Department
                              <span class="text-red-accent-4">*</span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" class="pa-1">
                          <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="from_designation_id"
                            :items="designations"
                            :item-title="(item) => `${item.name}`"
                            item-value="id"
                            :loading="designationsLoading"
                            autocomplete="off"
                            clearable
                            hide-details="auto"
                          >
                            <template #label>
                              From Designation
                              <span class="text-red-accent-4">*</span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col lg="6" md="6" cols="12" class="pa-1">
                          <v-autocomplete
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            v-model="to_designation_id"
                            :items="designations"
                            :item-title="(item) => `${item.name}`"
                            item-value="id"
                            :loading="designationsLoading"
                            autocomplete="off"
                            clearable
                            hide-details="auto"
                          >
                            <template #label>
                              To Designation
                              <span class="text-red-accent-4">*</span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>

                  <!-- Salary Information Comparison -->
                  <v-row class="ma-0">
                    <!-- Before Promotion Section (Read-Only Display) -->
                    <v-col lg="6" md="6" cols="12">
                      <v-card variant="outlined" class="pa-1">
                        <v-card-title class="text-subtitle-1 mb-0 pa-1">
                          <v-icon class="me-1" size="small">mdi-currency-usd</v-icon>
                          Current Salary (Auto-loaded from Employee)
                        </v-card-title>
                        <v-form class="pa-0">
                          <!-- <v-row class="ma-0">
                            <v-col cols="12" class="pa-1">
                              <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                                v-model="beforePackage"
                                :items="packageOptions"
                                :item-title="(item) => `${item.name}`"
                                item-value="id"
                        autocomplete="off"
                                clearable
                                hide-details="auto"
                              >
                                <template #label>Package</template>
                              </v-autocomplete>
                            </v-col>
                          </v-row> -->

                          <!-- Salary Components -->
                          <v-row class="pa-1">
                            <v-col cols="6">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                                v-model="beforeGrossSalary"
                                label="Gross Salary"
                        type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeBasic"
                                label="Basic"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeHouseRent"
                                label="House Rent"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeMedical"
                                label="Medical"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeEducation"
                                label="Education"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeMobile"
                                label="Mobile"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTransport"
                                label="Transport"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTechnical"
                                label="Technical"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeFestival"
                                label="Festival"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTiffin"
                                label="Tiffin"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeWash"
                                label="Wash"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeIncentive"
                                label="Incentive"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeOthers"
                                label="Others"
                                type="number"
                                readonly
                              />
                            </v-col>
                          </v-row>

                          <!-- Deduction Section -->
                          <v-divider class="my-4"></v-divider>
                          <v-card-title class="text-subtitle-2 bg-grey-lighten-4 pa-2">Deduction</v-card-title>
                          <v-row class="pa-1">
                            <v-col cols="6">
                      <v-text-field
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                                v-model="beforeTaxDeduct"
                                label="Tax Deduct"
                        type="number"
                        readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforePF"
                                label="PF"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeCarUse"
                                label="Car Use"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeGasBill"
                                label="Gas Bill"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeElectricityBill"
                                label="Electricity Bill"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeTelephoneBill"
                                label="Telephone Bill"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeInsurance"
                                label="Insurance"
                                type="number"
                                readonly
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="beforeOthersDeduct"
                                label="Others Deduct"
                                type="number"
                                readonly
                              />
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-card>
                    </v-col>

                    <!-- After Promotion Section -->
                    <v-col lg="6" md="6" cols="12">
                      <v-card variant="outlined" class="pa-1">
                        <v-card-title class="text-subtitle-1 mb-0 pa-1">
                          <v-icon class="me-1" size="small">mdi-trending-up</v-icon>
                          New Salary (Enter Promotion Details)
                        </v-card-title>
                        <v-form class="pa-0">
                  <!-- <v-row class="ma-0">
                    <v-col cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="afterPackage"
                        :items="packageOptions"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        autocomplete="off"
                        clearable
                        hide-details="auto"
                      >
                                <template #label>Package</template>
                      </v-autocomplete>
                    </v-col>
                  </v-row> -->

                          <!-- Salary Components -->
                          <v-row class="pa-1">
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterGrossSalary"
                                label="Gross Salary"
                                type="number"
                                placeholder="New Gross Salary"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterBasic"
                                label="Basic"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterHouseRent"
                                label="House Rent"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterMedical"
                                label="Medical"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterEducation"
                                label="Education"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterMobile"
                                label="Mobile"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTransport"
                                label="Transport"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTechnical"
                                label="Technical"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterFestival"
                                label="Festival"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTiffin"
                                label="Tiffin"
                                type="number"
                          />
                        </v-col>
                            <v-col cols="6">
                          <v-text-field
                                variant="outlined"
                            density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterWash"
                                label="Wash"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                            variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterIncentive"
                                label="Incentive"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterOthers"
                                label="Others"
                                type="number"
                          />
                        </v-col>
                      </v-row>

                          <!-- Deduction Section -->
                          <v-divider class="my-4"></v-divider>
                          <v-card-title class="text-subtitle-2 bg-grey-lighten-4 pa-2">Deduction</v-card-title>
                          <v-row class="pa-1">
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTaxDeduct"
                                label="Tax Deduct"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterPF"
                                label="PF"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterCarUse"
                                label="Car Use"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterGasBill"
                                label="Gas Bill"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterElectricityBill"
                                label="Electricity Bill"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterTelephoneBill"
                                label="Telephone Bill"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterInsurance"
                                label="Insurance"
                                type="number"
                              />
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                v-model="afterOthersDeduct"
                                label="Others Deduct"
                                type="number"
                          />
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                    </v-col>
                  </v-row>

                  <!-- Status and Action Buttons -->
                  <v-row class="ma-0 mt-0">
                    <v-col lg="3" md="3" cols="12" class="pa-1">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="status"
                        :items="statusOptions"
                        :item-title="(item) => `${item.text}`"
                        item-value="value"
                        :loading="loading"
                        autocomplete="off"
                        clearable
                        hide-details="auto"
                      >
                        <template #label>
                          Status
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col lg="9" md="9" cols="12" class="d-flex justify-end align-center">
                      <v-btn
                        color="error"
                        variant="outlined"
                        @click="resetForm"
                        :disabled="loading"
                        class="mr-2"
                      >
                        Reset
                      </v-btn>
                      <v-btn 
                        type="submit"
                        color="success" 
                        variant="flat" 
                        :loading="loading"
                        :disabled="loading"
                        prepend-icon="mdi-content-save"
                      >
                        SAVE
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'

// Store and Router
const store = useStore()
const router = useRouter()

// Temporary workaround for getEmployeeDetails function
const getEmployeeDetails = async (employeeId) => {
  try {
    const response = await store.dispatch('getEmployeeDetailsById', employeeId)
    return response.data
  } catch (error) {
    throw error
  }
}

// Helper function to get package name from ID
const getPackageName = (packageId) => {
  if (!packageId) return null
  const packageOption = packageOptions.value.find(pkg => pkg.id === packageId)
  return packageOption ? packageOption.name : null
}

// Panels
const panel = ref([0])
const panel1 = ref([0])
const panel2 = ref([0])

// Loading state
const loading = ref(false)
const employeesLoading = ref(false)
const departmentsLoading = ref(false)
const designationsLoading = ref(false)

// Form validation
const addPromotion = ref(null)

// Form fields with validation
const company_id = ref(null)
const branch_id = ref(null)
const employee_id = ref(null)
const ref_no = ref('')
const promotion_type = ref('regular')
const promotion_date = ref('')
const effect_date = ref('')
const promotionDateMenu = ref(false)
const effectDateMenu = ref(false)
const from_department_id = ref(null)
const to_department_id = ref(null)
const from_designation_id = ref(null)
const to_designation_id = ref(null)
const salary_increase = ref(0)
const status = ref('active')
const remarks = ref('')

// Additional required fields for promotion
const current_basic_salary = ref(0)
const new_basic_salary = ref(0)
const current_grade = ref('')
const new_grade = ref('')

// Package options
const beforePackage = ref(null)
const afterPackage = ref(null)

// Before promotion salary components
const beforeGrossSalary = ref(0)
const beforeBasic = ref(0)
const beforeHouseRent = ref(0)
const beforeMedical = ref(0)
const beforeEducation = ref(0)
const beforeMobile = ref(0)
const beforeTransport = ref(0)
const beforeTechnical = ref(0)
const beforeFestival = ref(0)
const beforeTiffin = ref(0)
const beforeWash = ref(0)
const beforeIncentive = ref(0)
const beforeOthers = ref(0)

// After promotion salary components
const afterGrossSalary = ref(0)
const afterBasic = ref(0)
const afterHouseRent = ref(0)
const afterMedical = ref(0)
const afterEducation = ref(0)
const afterMobile = ref(0)
const afterTransport = ref(0)
const afterTechnical = ref(0)
const afterFestival = ref(0)
const afterTiffin = ref(0)
const afterWash = ref(0)
const afterIncentive = ref(0)
const afterOthers = ref(0)

// Before promotion deductions
const beforeTaxDeduct = ref(0)
const beforePF = ref(0)
const beforeCarUse = ref(0)
const beforeGasBill = ref(0)
const beforeElectricityBill = ref(0)
const beforeTelephoneBill = ref(0)
const beforeInsurance = ref(0)
const beforeOthersDeduct = ref(0)

// After promotion deductions
const afterTaxDeduct = ref(0)
const afterPF = ref(0)
const afterCarUse = ref(0)
const afterGasBill = ref(0)
const afterElectricityBill = ref(0)
const afterTelephoneBill = ref(0)
const afterInsurance = ref(0)
const afterOthersDeduct = ref(0)

// Employee details
const employeeDetails = reactive({
  emp_id: '',
  name: '',
  department: '',
  designation: '',
  joining_date: '',
  mobile: '',
  email: '',
  employee_type: ''
})

// Dropdown options
const companies = ref([])
const branches = ref([])
const employees = ref([])
const departments = ref([])
const designations = ref([])

const promotionTypes = ref([
  { text: 'Regular', value: 'regular' },
  { text: 'Merit', value: 'merit' },
  { text: 'Seniority', value: 'seniority' },
  { text: 'Special', value: 'special' },
  { text: 'Lateral', value: 'lateral' }
])

const statusOptions = ref([
  { text: 'Active', value: 'active' },
  { text: 'Inactive', value: 'inactive' }
])

const packageOptions = ref([
  { id: 1, name: 'Basic Package' },
  { id: 2, name: 'Standard Package' },
  { id: 3, name: 'Premium Package' },
  { id: 4, name: 'Executive Package' },
  { id: 5, name: 'Enhanced Package' }
])

// Methods
const loadCompanies = async () => {
  try {
    const response = await store.dispatch('companySetup/getCompanyList', {})
    companies.value = response.data.data || []
  } catch (error) {
    // Companies loading failed
  }
}

const loadBranches = async () => {
  if (!company_id.value.value) return
  
  try {
    const response = await store.dispatch('branchSetup/getBranchList', { company_id: company_id.value.value })
    branches.value = response.data.data || []
  } catch (error) {
    // Branches loading failed
  }
}

const loadEmployees = async () => {
  employeesLoading.value = true
  try {
    const response = await store.dispatch('getEmployees')
    
    if (response.data.success && response.data.data) {
      employees.value = response.data.data
    } else if (response.data.data) {
      employees.value = response.data.data
    } else {
      employees.value = []
      toast.error('No employee data found in response')
    }
  } catch (error) {
    employees.value = []
    toast.error(`Failed to load employees: ${error.message || 'Unknown error'}`)
  } finally {
    employeesLoading.value = false
  }
}

const loadDepartments = async () => {
  departmentsLoading.value = true
  try {
    const response = await store.dispatch('getDepartments')
    if (response.data.success && response.data.data) {
      departments.value = response.data.data
    } else if (response.data.data) {
      departments.value = response.data.data
    } else {
      departments.value = []
    }
  } catch (error) {
    departments.value = []
    toast.error('Failed to load departments')
  } finally {
    departmentsLoading.value = false
  }
}

const loadDesignations = async () => {
  designationsLoading.value = true
  try {
    const response = await store.dispatch('getDesignations')
    if (response.data.success && response.data.data) {
      designations.value = response.data.data
    } else if (response.data) {
      designations.value = response.data
    } else {
      designations.value = []
    }
  } catch (error) {
    designations.value = []
    toast.error('Failed to load designations')
  } finally {
    designationsLoading.value = false
  }
}

const loadEmployeeDetails = async () => {
  if (!employee_id.value) return
  
  try {
    // Get details from the selected employee in the dropdown
    const selectedEmployee = employees.value.find(emp => emp.id === employee_id.value)
    if (selectedEmployee) {
      Object.assign(employeeDetails, {
        emp_id: selectedEmployee.code || selectedEmployee.employee_code || selectedEmployee.emp_id || '',
        name: selectedEmployee.name || '',
        department: selectedEmployee.department?.name || selectedEmployee.department || '',
        designation: selectedEmployee.designation?.name || selectedEmployee.designation || '',
        joining_date: selectedEmployee.joining_date || '',
        mobile: selectedEmployee.mobile || '',
        email: selectedEmployee.email || '',
        employee_type: selectedEmployee.employeeType?.name || selectedEmployee.employee_type?.name || selectedEmployee.employee_type || ''
      })
      
      // Set current department and designation for from fields
      const currentDept = departments.value.find(dept => dept.name === employeeDetails.department)
      const currentDesig = designations.value.find(desig => desig.name === employeeDetails.designation)
      
      if (currentDept) from_department_id.value = currentDept.id
      if (currentDesig) from_designation_id.value = currentDesig.id
    }
    
    // Try to get more detailed info from API (optional)
    try {
      if (typeof getEmployeeDetails === 'function') {
        const response = await getEmployeeDetails(employee_id.value)
        
        if (response.success && response.data) {
          const emp = response.data
          Object.assign(employeeDetails, {
            emp_id: emp.code || emp.employee_code || emp.emp_id || employeeDetails.emp_id,
            name: emp.name || employeeDetails.name,
            department: emp.department?.name || emp.department || employeeDetails.department,
            designation: emp.designation?.name || emp.designation || employeeDetails.designation,
            joining_date: emp.joining_date || employeeDetails.joining_date,
            mobile: emp.mobile || employeeDetails.mobile,
            email: emp.email || employeeDetails.email,
            employee_type: emp.employeeType?.name || emp.employee_type?.name || emp.employee_type || employeeDetails.employee_type
          })
        }
      }
    } catch (apiError) {
      // Use selection data as fallback
    }
    
    // Always try to load salary information
    await loadCurrentSalary()
  } catch (error) {
    // Still try to load salary even if there's an error
    await loadCurrentSalary()
  }
}

const loadCurrentSalary = async () => {
  try {
    const response = await store.dispatch('getEmployeeSalaryInfoById', employee_id.value)
    
    if (response.data.success && response.data.data && response.data.data.length > 0) {
      // Get the most recent salary record (first in the array since it's ordered by effect_date desc)
      const salaryData = response.data.data[0]
      
      // Populate package information
      if (salaryData.package) {
        const matchingPackage = packageOptions.value.find(pkg => pkg.name === salaryData.package)
        beforePackage.value = matchingPackage ? matchingPackage.id : null
      } else {
        beforePackage.value = null
      }
      
      // Populate before promotion salary components
      beforeGrossSalary.value = salaryData.gross_salary || 0
      beforeBasic.value = salaryData.basic_salary || 0
      current_basic_salary.value = salaryData.basic_salary || 0
      beforeHouseRent.value = salaryData.house_rent || 0
      beforeMedical.value = salaryData.medical || 0
      beforeEducation.value = salaryData.education || 0
      beforeMobile.value = salaryData.mobile || 0
      beforeTransport.value = salaryData.transport || 0
      beforeTechnical.value = salaryData.technical || 0
      beforeFestival.value = salaryData.festival_allowance || 0
      beforeTiffin.value = salaryData.tiffin || 0
      beforeWash.value = salaryData.wash || 0
      beforeIncentive.value = salaryData.incentive || 0
      beforeOthers.value = salaryData.others || 0
      
      // Populate before promotion deductions
      beforeTaxDeduct.value = salaryData.tax_deducted || 0
      beforePF.value = salaryData.pf_provident_fund || 0
      beforeCarUse.value = salaryData.car_use || 0
      beforeGasBill.value = salaryData.gas_bill || 0
      beforeElectricityBill.value = salaryData.electricity_bill || 0
      beforeTelephoneBill.value = salaryData.telephone_bill || 0
      beforeInsurance.value = salaryData.insurance || 0
      beforeOthersDeduct.value = salaryData.others_deducted || salaryData.others_deduct || 0
      
    } else {
      toast.warning('No salary information found for this employee')
    }
  } catch (error) {
    toast.error('Failed to load employee salary information')
  }
}

const calculateSalaryIncrease = () => {
  const before = parseFloat(beforeGrossSalary.value) || 0
  const after = parseFloat(afterGrossSalary.value) || 0
  salary_increase.value = after - before
}

// Watch for salary changes
watch(() => afterGrossSalary.value, () => {
  calculateSalaryIncrease()
})

// Watch for after basic salary changes
watch(() => afterBasic.value, () => {
  new_basic_salary.value = afterBasic.value
  calculateSalaryIncrease()
})

// Watch for date changes to ensure clean date format
watch(() => promotion_date.value, (newDate) => {
  if (newDate && typeof newDate === 'object') {
    // Convert Date object to clean string format
    const year = newDate.getFullYear()
    const month = String(newDate.getMonth() + 1).padStart(2, '0')
    const day = String(newDate.getDate()).padStart(2, '0')
    promotion_date.value = `${year}-${month}-${day}`
  }
})

watch(() => effect_date.value, (newDate) => {
  if (newDate && typeof newDate === 'object') {
    // Convert Date object to clean string format
    const year = newDate.getFullYear()
    const month = String(newDate.getMonth() + 1).padStart(2, '0')
    const day = String(newDate.getDate()).padStart(2, '0')
    effect_date.value = `${year}-${month}-${day}`
  }
})

const submit = async () => {
  loading.value = true
  
  try {
    // Validate required fields
    if (!employee_id.value) {
      toast.error('Please select an employee')
      return
    }
    
    if (!ref_no.value) {
      toast.error('Please enter reference number')
      return
    }
    
    if (!promotion_date.value) {
      toast.error('Please select promotion date')
      return
    }
    
    if (!effect_date.value) {
      toast.error('Please select effect date')
      return
    }
    
    if (!from_department_id.value) {
      toast.error('Please select from department')
      return
    }
    
    if (!to_department_id.value) {
      toast.error('Please select to department')
      return
    }
    
    if (!from_designation_id.value) {
      toast.error('Please select from designation')
      return
    }
    
    if (!to_designation_id.value) {
      toast.error('Please select to designation')
      return
    }
    
    if (!new_basic_salary.value || new_basic_salary.value <= current_basic_salary.value) {
      toast.error('New basic salary must be greater than current basic salary')
      return
    }
    
    if (!afterGrossSalary.value || afterGrossSalary.value <= beforeGrossSalary.value) {
      toast.error('New gross salary must be greater than current gross salary')
      return
    }

    const promotionData = {
      employee_id: employee_id.value,
      ref_no: ref_no.value,
      promotion_type: promotion_type.value,
      promotion_date: promotion_date.value,
      effect_date: effect_date.value,
      current_department_id: from_department_id.value,
      new_department_id: to_department_id.value,
      current_designation_id: from_designation_id.value,
      new_designation_id: to_designation_id.value,
      current_basic_salary: current_basic_salary.value,
      new_basic_salary: new_basic_salary.value,
      salary_increment_amount: salary_increase.value,
      current_grade: current_grade.value,
      new_grade: new_grade.value,
      status: status.value,
      remarks: remarks.value,
      
      // After promotion data
      after_package: getPackageName(afterPackage.value),
      after_salary: {
        gross_salary: afterGrossSalary.value,
        basic: afterBasic.value,
        house_rent: afterHouseRent.value,
        medical: afterMedical.value,
        education: afterEducation.value,
        mobile: afterMobile.value,
        transport: afterTransport.value,
        technical: afterTechnical.value,
        festival: afterFestival.value,
        tiffin: afterTiffin.value,
        wash: afterWash.value,
        incentive: afterIncentive.value,
        others: afterOthers.value
      },
      after_deduction: {
        tax_deduct: afterTaxDeduct.value,
        pf: afterPF.value,
        car_use: afterCarUse.value,
        gas_bill: afterGasBill.value,
        electricity_bill: afterElectricityBill.value,
        telephone_bill: afterTelephoneBill.value,
        insurance: afterInsurance.value,
        others_deduct: afterOthersDeduct.value
      }
    }
    
    let response
    const editingPromotion = store.getters['hrmPromotion/getEditingPromotion']
    
       if (editingPromotion) {
         // Update existing promotion
         response = await store.dispatch('hrmPromotion/updatePromotion', { id: editingPromotion.id, promotionData })
         if (response.success) {
           store.commit('hrmPromotion/clearEditingPromotion')
         }
       } else {
      // Create new promotion
      response = await store.dispatch('hrmPromotion/saveOrUpdatePromotion', promotionData)
      if (response.success) {
        // Promotion saved successfully
      }
    }
    
    if (response.success) {
      resetForm()
      router.push('/hrm/promotion-list')
    } else {
      toast.error(response.message || 'Failed to save promotion')
    }
    
  } catch (error) {
    toast.error(error.response?.data?.message || 'Failed to save promotion')
  } finally {
    loading.value = false
  }
}

const resetForm = () => {
  employee_id.value = null
  ref_no.value = ''
  promotion_type.value = 'regular'
  promotion_date.value = ''
  effect_date.value = ''
  promotionDateMenu.value = false
  effectDateMenu.value = false
  from_department_id.value = null
  to_department_id.value = null
  from_designation_id.value = null
  to_designation_id.value = null
  salary_increase.value = 0
  status.value = 'active'
  remarks.value = ''
  
  // Reset additional fields
  current_basic_salary.value = 0
  new_basic_salary.value = 0
  current_grade.value = ''
  new_grade.value = ''
  
  // Reset package selections
  beforePackage.value = null
  afterPackage.value = null
  
  // Reset before salary components
  beforeGrossSalary.value = 0
  beforeBasic.value = 0
  beforeHouseRent.value = 0
  beforeMedical.value = 0
  beforeEducation.value = 0
  beforeMobile.value = 0
  beforeTransport.value = 0
  beforeTechnical.value = 0
  beforeFestival.value = 0
  beforeTiffin.value = 0
  beforeWash.value = 0
  beforeIncentive.value = 0
  beforeOthers.value = 0
  
  // Reset after salary components
  afterGrossSalary.value = 0
  afterBasic.value = 0
  afterHouseRent.value = 0
  afterMedical.value = 0
  afterEducation.value = 0
  afterMobile.value = 0
  afterTransport.value = 0
  afterTechnical.value = 0
  afterFestival.value = 0
  afterTiffin.value = 0
  afterWash.value = 0
  afterIncentive.value = 0
  afterOthers.value = 0
  
  // Reset before deductions
  beforeTaxDeduct.value = 0
  beforePF.value = 0
  beforeCarUse.value = 0
  beforeGasBill.value = 0
  beforeElectricityBill.value = 0
  beforeTelephoneBill.value = 0
  beforeInsurance.value = 0
  beforeOthersDeduct.value = 0
  
  // Reset after deductions
  afterTaxDeduct.value = 0
  afterPF.value = 0
  afterCarUse.value = 0
  afterGasBill.value = 0
  afterElectricityBill.value = 0
  afterTelephoneBill.value = 0
  afterInsurance.value = 0
  afterOthersDeduct.value = 0
  
  Object.assign(employeeDetails, {
    emp_id: '',
    name: '',
    department: '',
    designation: '',
    joining_date: '',
    mobile: '',
    email: '',
    employee_type: ''
  })
}

// Generate reference number
const generateReferenceNumber = async () => {
  try {
    const response = await store.dispatch('hrmPromotion/generatePromotionReferenceNumber')
    if (response.success) {
      ref_no.value = response.data.ref_no
    }
  } catch (error) {
    // Reference number generation failed, user can enter manually
  }
}

const loadEditingPromotion = async (promotionData) => {
  try {
    console.log('Loading editing promotion data:', promotionData)
    console.log('Current department ID:', promotionData.current_department_id)
    console.log('New department ID:', promotionData.new_department_id)
    console.log('Current designation ID:', promotionData.current_designation_id)
    console.log('New designation ID:', promotionData.new_designation_id)
    
    // Populate basic promotion data
    employee_id.value = promotionData.employee?.id || promotionData.employee_id
    ref_no.value = promotionData.ref_no
    promotion_type.value = promotionData.promotion_type
    promotion_date.value = formatDateForInput(promotionData.promotion_date)
    effect_date.value = formatDateForInput(promotionData.effect_date)
    from_department_id.value = promotionData.current_department_id || promotionData.from_department_id
    to_department_id.value = promotionData.new_department_id || promotionData.to_department_id
    from_designation_id.value = promotionData.current_designation_id || promotionData.from_designation_id
    to_designation_id.value = promotionData.new_designation_id || promotionData.to_designation_id
    
    console.log('Set from_department_id:', from_department_id.value)
    console.log('Set to_department_id:', to_department_id.value)
    console.log('Set from_designation_id:', from_designation_id.value)
    console.log('Set to_designation_id:', to_designation_id.value)
    salary_increase.value = promotionData.salary_increase
    status.value = promotionData.status
    remarks.value = promotionData.remarks || ''
    
    // Load additional required fields
    current_basic_salary.value = promotionData.current_basic_salary || 0
    new_basic_salary.value = promotionData.new_basic_salary || 0
    current_grade.value = promotionData.current_grade || ''
    new_grade.value = promotionData.new_grade || ''
    
    // Ensure departments and designations are loaded
    if (departments.value.length === 0) {
      await loadDepartments()
    }
    if (designations.value.length === 0) {
      await loadDesignations()
    }
    
    // Small delay to ensure dropdowns are fully loaded
    await new Promise(resolve => setTimeout(resolve, 100))
    
    console.log('Available departments:', departments.value)
    console.log('Available designations:', designations.value)
    
    // Load employee details
    await loadEmployeeDetails()
    
    // Populate after promotion salary data (if available)
    console.log('After package from data:', promotionData.after_package)
    console.log('Available package options:', packageOptions.value)
    if (promotionData.after_package) {
      const packageId = getPackageIdByName(promotionData.after_package)
      console.log('Found package ID:', packageId)
      afterPackage.value = packageId
    }
    console.log('Loading after promotion salary data:')
    console.log('- after_gross_salary:', promotionData.after_gross_salary)
    console.log('- after_basic:', promotionData.after_basic)
    console.log('- after_house_rent:', promotionData.after_house_rent)
    
    afterGrossSalary.value = promotionData.after_gross_salary || 0
    afterBasic.value = promotionData.after_basic || 0
    afterHouseRent.value = promotionData.after_house_rent || 0
    afterMedical.value = promotionData.after_medical || 0
    afterEducation.value = promotionData.after_education || 0
    afterMobile.value = promotionData.after_mobile || 0
    afterTransport.value = promotionData.after_transport || 0
    afterTechnical.value = promotionData.after_technical || 0
    afterFestival.value = promotionData.after_festival || 0
    afterTiffin.value = promotionData.after_tiffin || 0
    afterWash.value = promotionData.after_wash || 0
    afterIncentive.value = promotionData.after_incentive || 0
    afterOthers.value = promotionData.after_others || 0
    
    afterTaxDeduct.value = promotionData.after_tax_deduct || 0
    afterPF.value = promotionData.after_pf || 0
    afterCarUse.value = promotionData.after_car_use || 0
    afterGasBill.value = promotionData.after_gas_bill || 0
    afterElectricityBill.value = promotionData.after_electricity_bill || 0
    afterTelephoneBill.value = promotionData.after_telephone_bill || 0
    afterInsurance.value = promotionData.after_insurance || 0
    afterOthersDeduct.value = promotionData.after_others_deduct || 0
    
  } catch (error) {
    console.error('Error loading promotion data:', error)
    toast.error('Failed to load promotion data for editing')
  }
}

const formatDateToString = (date) => {
  if (!date) return ''
  try {
    // If it's already a string, return as is
    if (typeof date === 'string') return date
    
    // If it's a Date object, convert to clean string
    if (date instanceof Date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    
    return ''
  } catch (error) {
    console.error('Date formatting error:', error)
    return ''
  }
}

const formatDateForInput = (dateString) => {
  if (!dateString) return ''
  try {
    // Handle both ISO format and date-only format
    let date
    if (dateString.includes('T')) {
      // ISO format: 2025-09-14T18:00:00.000000Z
      date = new Date(dateString)
    } else {
      // Date only format: 2025-09-15
      date = new Date(dateString + 'T00:00:00')
    }
    
    // Return clean date string without time or timezone
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    
    return `${year}-${month}-${day}` // Returns YYYY-MM-DD format only
  } catch (error) {
    console.error('Date formatting error:', error)
    return ''
  }
}

const getPackageIdByName = (packageName) => {
  if (!packageName) return null
  const packageOption = packageOptions.value.find(pkg => pkg.name === packageName)
  return packageOption ? packageOption.id : null
}


// Watch for route changes to handle navigation
watch(() => router.currentRoute.value.path, (newPath) => {
  if (newPath === '/hrm/add-promotion') {
    console.log('Route changed to add promotion, checking editing state')
    const editingPromotion = store.getters['hrmPromotion/getEditingPromotion']
    if (!editingPromotion || !editingPromotion.id) {
      console.log('No valid editing promotion, clearing state')
      store.commit('hrmPromotion/clearEditingPromotion')
      resetForm()
    }
  }
}, { immediate: false })

// Initialize
onMounted(async () => {
  await loadEmployees()
  await loadDepartments()
  await loadDesignations()
  
  // Check if we're editing an existing promotion
  const editingPromotion = store.getters.getEditingPromotion
  
  // Check if we have a valid editing promotion with an ID
  if (editingPromotion && editingPromotion.id) {
    console.log('Loading editing promotion:', editingPromotion.id)
    await loadEditingPromotion(editingPromotion)
  } else {
    // Always clear any stale editing state and start fresh
    console.log('Clearing editing state and starting fresh')
    store.commit('hrmPromotion/clearEditingPromotion')
    resetForm()
    await generateReferenceNumber()
  }
})

onBeforeUnmount(() => {
  store.commit('hrmPromotion/clearEditingPromotion')
  resetForm()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

/* Reduce spacing between elements */
.v-container {
  padding: 8px !important;
}

.v-expansion-panels {
  margin-bottom: 4px !important;
}

.v-expansion-panel-text__wrapper {
  padding: 4px 8px !important;
}

.v-card {
  margin-bottom: 4px !important;
}

.v-card-title {
  padding: 8px 12px !important;
  margin-bottom: 0 !important;
}

/* Reduce form field spacing */
.v-form {
  padding: 4px !important;
}

/* Compact spacing for better density */
.v-row {
  margin: 0 !important;
}

.v-col {
  padding: 2px !important;
}
</style>
